import { IProduct } from '../../model';

export const sortCartProducts = (products: IProduct[]) => {
  const tryItFirstItems = products.filter((product) => product.tryItFirstId !== 0);

  if (tryItFirstItems.length === 0) {
    return products;
  }

  const cartItems = products.filter((product) => product.tryItFirstId === 0);

  if (tryItFirstItems.length !== 0) {
    tryItFirstItems.forEach((p) => {
      const productArrayIndex = cartItems.findIndex((product) => {
        return product.itemId === p.tryItFirstId;
      });

      if (productArrayIndex !== -1) {
        cartItems.splice(productArrayIndex + 1, 0, p);
      }
    });
  }

  return cartItems;
};
